import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Subscription, empty } from 'rxjs';
import {
  map,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
} from 'rxjs/operators';
import { ManualOrderService } from 'src/app/core/services/api-services/manual-order.service';
import { Patient, Address, Insurance, DrugList } from './patient';
import { MatDialog } from '@angular/material/dialog';
import { AddOrderModalComponent } from './add-order-modal/add-order-modal.component';
import { AddInsuranceModalComponent } from './add-insurance-modal/add-insurance-modal.component';
import { MatSelectChange } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { RouteConstants } from 'src/app/core/constants/RouteConstants';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from 'src/app/core/services/form.service';
import { AddDrugModalComponent } from './add-drug-modal/add-drug-modal.component';
import { KRollService } from 'src/app/core/services/api-services/kroll.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { AddNursingHomeModalComponent } from './add-nursing-home-modal/add-nursing-home-modal.component';
import { ChangeDetectorRef } from '@angular/core';
import { VisitService } from 'src/app/core/services/wylo-services/visit.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-manual-order',
  templateUrl: './manual-order.component.html',
  styleUrls: ['./manual-order.component.scss'],
})
export class ManualOrderComponent implements OnInit {
  tenant =  localStorage.getItem('tenant'); 
  // Properties declaration
  selectedUserId: string = '';
  progress_spinner: boolean = false;
  patientList: Patient[] = [];
  addressList: Address[] = [];
  insuranceList: Insurance[] = [];
  manualForm: FormGroup | any;
  patientCtrlSubscription: Subscription | any;
  reasonType: any;
  patientId: any =0;
  addressId: number = 0;
  positiveNumberRegex = /^[0-9]\d*$/;
  positiveAmountRegex = /^\d*\.?\d{0,2}$/; ///^\d*\.?\d+$/;
  positiveAmountRegexCost = /^(?!0\.00$)(?:0*(?:[1-9]\d{0,}))?(?:\.\d{1,2})?$/; // /^\d*\.?\d{0,2}$/;

  AddOnInfo: any = FormGroup;
  AddOnInfoData: any[] = [];
  isCollapsed: { [key: string]: boolean } = {};

  AddInsuranceform: any = FormGroup;
  selectedInsurance: any;
  InsuranceArray: any[] = [];
  SelectedInsuranceName: any;
  DefaultInsuranceArray: any[] = [];

  selectedDrugId: number = 0;
  drugList: DrugList[] = [];
  drugCtrlSubscription: Subscription | any;
  IfRxIdValid: boolean = false;
  IfORxIdValid: boolean = false;
  IsRxsValid: boolean = false;
  Copay: number = 0;
  nursingHomes: any[] = [];
  NursingData:any[]=[];
  IsNursingDDActive : any = true;
  IsRxEditMode: boolean = false;
  EditIndex: number = 0;
  RxButton:any='Add More';
  DINList: any = [];
  Is2nd:any = false;
  setDefaultPatient:string = '';
  isPatientvalid:boolean = true;
  isDrugvalid:boolean = true;
  isForQc:boolean = true;
  isQtyvalid:boolean = true;
  vid: any;
  visiteDetail:any = [];
  private encryptionKey = 'VisitModule';


  constructor(
    private formBuilder: FormBuilder,
    private manualService: ManualOrderService,
    public dialog: MatDialog,
    public toastr: ToastrService,
    public RouteConstants: RouteConstants,
    private router: Router,
    public formService: FormService,
    public krollService: KRollService,
    public helperService: HelperService,
    private route: ActivatedRoute,
    public cdr : ChangeDetectorRef,
    public visitService: VisitService,
  ) {}

  ngOnInit(): void {
    if(this.tenant == 'wylo'){
      this.vid = this.decryptAndGetCode(this.route.snapshot.paramMap.get('vid'));
      this.getVisitById();
    }
    this.initializeForm();
    this.getNursingHome();

    if(this.formService.selectedLocation.value == 9){
      this.isForQc = false;
    }

    // this.AddOnInfoData =[
    //   {
    //     "ID": "2345",
    //     "OrigRxNum": "2345",
    //     "PatID": null,
    //     "address_id": null,
    //     "DrugName": "Advil Pediatric Drops Grape Dye Free (Ibuprofen)",
    //     "DrgID": 279691,
    //     "RxNum": "2345",
    //     "AAC": "30",
    //     "Cost": "30",
    //     "Markup": "0",
    //     "Fee": "0",
    //     "BaseCost": "30",
    //     "DiscountCost": "0",
    //     "DiscountMarkup": "0",
    //     "DiscountFee": "0",
    //     "DispQty": 6,
    //     "NextFillQty": null,
    //     "Lastfilledqty": null,
    //     "AuthQty": 10,
    //     "RemQty": 4,
    //     "AvailableQty": 10,
    //     "AutoRefill": 0,
    //     "DaysSupply": 10,
    //     "FillDate": "2024-03-14",
    //     "FirstFillDate": "2024-03-12",
    //     "LastFillDate": "2024-03-21",
    //     "FillExpiryDate": "2024-03-23",
    //     "RxID": "2345",
    //     "kroll_drg": {
    //       "ID": 279691,
    //       "BrandName": "Advil Pediatric Drops Grape Dye Free (Ibuprofen)",
    //       "GenericName": "Advil Pediatric Drops Grape Dye Free (Ibuprofen)",
    //       "Strength": "40mg",
    //       "DIN": "324",
    //       "Form": "dsfg",
    //       "Schedule": "dfgh",
    //       "Instructions": "dfgh"
    //     },
    //     "Insurancedata": [
    //       {
    //         "pays": 28,
    //         "subplan": 6929,
    //         "CareerNumber": "35467543",
    //         "subplanname": "test0000"
    //       },
    //       {
    //         "pays": 2,
    //         "subplan": 0,
    //         "CareerNumber": 0,
    //         "subplanname": "Cash"
    //       }
    //     ]
    //   }
    // ]
  }

  decryptAndGetCode(_vid: any) {
    const encryptedValue = _vid;
    if (encryptedValue) {
      const bytes = CryptoJS.AES.decrypt(encryptedValue, this.encryptionKey);
      const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decrypted;
    }
  }

  getVisitById() {
    this.visitService.visitById(this.vid).subscribe(
      (res: any) => {
        if (res['body']['success'] && res['body']['data']) {
          this.visiteDetail = res['body']['data'][0];
          this.onSelect(this.visiteDetail.user);
          let obj = {value:'acute'};
          this.onShippingTypeChange(obj);
        }
      });
  }

  getNursingHome() {
    this.krollService.nursingHomes.subscribe(
      (res) => (this.nursingHomes = res)
    );
  }

  onSelectNursing(homes: any){
    //console.log(homes);
    this.NursingData.push({
      ID: homes.ID,
      Name: homes.Name
    });
  }

  onShippingTypeChange(event: any){
    //console.log('Selected Shipping Type:', event.value);
    if (event.value == 'chronic'){
      this.IsNursingDDActive = true;
    }else{
      this.IsNursingDDActive = false;
    }
  }

  AddOnInfoReset(){
    this.AddOnInfo.get('FirstFilleddate').setValue(new Date());
    this.AddOnInfo.get('LastFilleddate').setValue(new Date());
    this.AddOnInfo.get('Filldate').setValue(new Date());
    this.AddOnInfo.get('FillExpiryDate').setValue(new Date());
    this.AddOnInfo.get('Cost').setValue(0);
    this.AddOnInfo.get('Markup').setValue(0);
    this.AddOnInfo.get('Fee').setValue(0);
  }


  // Initialize form and subscribe to patient value changes
  initializeForm() {
    this.manualForm = this.formBuilder.group({
      patient: [{value:'',disabled: this.tenant == 'wylo'}],
      address: [''],
      shippingType:[{value: this.tenant == 'wylo' ? 'acute' : 'chronic', disabled: this.tenant == 'wylo'}]
    });
    
    this.setDefaultPatient = this.route.snapshot.queryParamMap.get('email') ?? '';
    this.manualForm.get('patient').setValue(this.setDefaultPatient);
    if(this.setDefaultPatient != ''){
      this.initializePatientCtrlSubscription();
      const payload = {search: this.setDefaultPatient, server_location: this.formService.selectedLocation.value,}
      this.manualService.getUserList(payload).subscribe(
        (res: any) => {
          if (res.body.success) {
            this.onSelect(res?.body?.data[0]);
            this.manualForm.get('shippingType').setValue('acute');
          } 
          else {
            this.IsRxsValid = false;
            this.toastr.error(res.body.message);
          }
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    }else{
      this.initializePatientCtrlSubscription();
    }

    this.initializeAddonInfo();

    this.AddInsuranceform = this.formBuilder.group({
      pays: ['', Validators.compose([Validators.required,Validators.pattern(this.positiveAmountRegex)])],
      subplan: [0, Validators.compose([Validators.required])],
    });
    this.initializeDrugCtrlSubscription();
    this.initializeDINCtrlSubscription();
  }


  initializeAddonInfo(){
    this.AddOnInfo = this.formBuilder.group({
      RxId: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(/^\d+$/),
          Validators.min(1),
        ])
      ),
      OrignalRxId: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(/^\d+$/),
          Validators.min(1),
        ])
      ),
      DrugID: [''],
      DrugName: ['', Validators.compose([Validators.required])],
      Strength: ['', Validators.compose([Validators.required])],
      DIN: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.positiveNumberRegex),
          Validators.min(1),
        ]),
      ],
      Form: ['', Validators.compose([Validators.required])],
      Dosage: [''],
      Instructions: [''],
      Authqty: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.positiveNumberRegex),
          Validators.min(1),
        ]),
      ],
      AvailableQty: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.positiveNumberRegex),
          Validators.min(0),
        ]),
      ],
      Lastfilledqty: [''],
      Remainingqty: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.positiveNumberRegex),
          Validators.min(0),
        ]),
      ],
      DispQty: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.positiveNumberRegex),
          Validators.min(0),
        ]),
      ],
      NextFillQty: [''],
      DaysSupply: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.positiveNumberRegex),
          Validators.min(0),
        ]),
      ],
      FirstFilleddate: [new Date()],
      LastFilleddate: [''],
      Filldate: [new Date()],
      FillExpiryDate: [new Date()],
      AutoRefill: [false],
      AAC: [''],
      Cost: ['',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.positiveAmountRegexCost),
        Validators.min(1),
      ])],
      Markup: ['',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.positiveAmountRegex),
        Validators.min(0),
      ])],
      Fee: ['',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.positiveAmountRegex),
        Validators.min(0),
      ])],
      BaseCost: [''],
      DiscountCost: ['0',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.positiveAmountRegex),
        Validators.min(0),
      ])],
      DiscountMarkup: ['0',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.positiveAmountRegex),
        Validators.min(0),
      ])],
      DiscountFee: ['0',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.positiveAmountRegex),
        Validators.min(0),
      ])],
      Cash: [
        '0',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.positiveAmountRegex),
          Validators.min(0),
        ])],
    });
    if (this.Is2nd == false) {
      this.AddOnInfo.setValidators(this.dateValidator);
    }

   /* this.AddInsuranceform = this.formBuilder.group({
      pays: ['', Validators.compose([Validators.required,Validators.pattern(this.positiveAmountRegex)])],
      subplan: [0, Validators.compose([Validators.required])],
    });
    this.initializeDrugCtrlSubscription();
    this.initializeDINCtrlSubscription(); */
  }

  // Subscribe to patient control value changes
  initializePatientCtrlSubscription() {
    this.patientCtrlSubscription = this.manualForm
      .get('patient')
      .valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => (this.progress_spinner = true)),
        switchMap((searchTerm: any) => {
          //debugger;
          if (searchTerm.length >= 3) {
            return this.manualService
              .getUserList({
                search: searchTerm,
                server_location: this.formService.selectedLocation.value,
              })
              .pipe(
                map(
                  (response) => {
                    if (response?.body?.success) {
                      this.patientList = response?.body?.data;
                      this.progress_spinner = false;
                      return response?.body?.data;
                    } else {
                      //console.log(response?.body?.message);
                      this.progress_spinner = false;
                      this.patientList =[];
                      return [];
                    }
                  },
                  (err: any) => {
                    console.error('API FAILED', err);
                  }
                )
              );
          } else {
            this.patientList = [];
            this.progress_spinner = false;
            return [];
          }
        }),
        tap(() => (this.progress_spinner = false))
      )
      .subscribe((patients: Patient[]) => {
        this.patientList = patients;
      });
  }

  // Clear patient and address form controls and reset patientList array
  onClear() {
    this.manualForm.get('patient').setValue('');
    this.manualForm.get('address').setValue('');
    this.patientList = []; // Reset patientList array
    this.addressList = [];
    this.insuranceList = [];
    this.patientId =0;

    this.manualForm.reset();
    this.AddOnInfo.reset();

    this.AddInsuranceform.reset();
    this.AddOnInfo.get('RxId').enable();
    this.AddOnInfo.get('OrignalRxId').enable();
    this.AddOnInfoData = [];
    this.selectedInsurance ='';
    this.InsuranceArray = [];
    this.SelectedInsuranceName = '';
    this.DefaultInsuranceArray = []; 
    this.selectedDrugId = 0;
    this.drugList = [];
    this.IfRxIdValid = false;
    this.IfORxIdValid = false;
    this.IsRxsValid = false;
    this.Copay = 0;
    this.IsNursingDDActive = true;
    this.Is2nd = false;
    this.isPatientvalid = true;
    this.isDrugvalid = true;

    this.initializePatientCtrlSubscription();
    this.initializeForm();
  }

  // Handle patient selection
  onSelect(patient: Patient) {
    const user_id = patient.id;
    this.patientId = patient.id;
    let patientDetails = patient.name + ' | ' + patient.email;

    if (patient.providerName) {
      patientDetails += ' | ' + patient.providerName;
    }

    this.manualForm.get('patient')?.setValue(patientDetails);
    this.selectedUserId = patient.id;
    //this.patientCtrlSubscription.unsubscribe();
    this.getlist(user_id);
    this.isPatientvalid = true;
  }

  onPatientblur(){
    if(this.patientId == 0){
      this.isPatientvalid = false;
    }
    else{
      this.isPatientvalid = true;
    }
  }

  // Initialize Drug dropdown list
  initializeDrugCtrlSubscription() {
    this.drugCtrlSubscription = this.AddOnInfo.get('DrugName')
      .valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => (this.progress_spinner = true)),
        switchMap((searchTerm: any) => {
          if (searchTerm.length >= 3) {
            return this.manualService.getDrugList({ search: searchTerm }).pipe(
              map(
                (response) => {
                  if (response?.body?.success) {
                    this.drugList = response?.body?.data;
                    //console.log(this.drugList);

                    this.progress_spinner = false;
                    return response?.body?.data;
                  } else {
                    //console.log(response?.body?.message);
                    this.progress_spinner = false;
                    return [];
                  }
                },
                (err: any) => {
                  console.error('API FAILED', err);
                }
              )
            );
          } else {
            this.progress_spinner = false;
            this.drugList = [];
            return [];
          }
        }),
        tap(() => (this.progress_spinner = false))
      )
      .subscribe((drugs: DrugList[]) => {
        this.drugList = drugs;
        //console.log(this.drugList);
      });
  }

  // Handle Drug selection
  onSelectDrug(drug: any) {
    this.AddOnInfo.get('DrugName')?.setValue(drug.name);
    this.AddOnInfo.get('DrugID')?.setValue(drug.id);
    this.AddOnInfo.get('Strength')?.setValue(drug.strength);
    this.AddOnInfo.get('DIN')?.setValue(drug.din ?? '');
    this.AddOnInfo.get('Form')?.setValue(drug.durg_from ?? '');
    this.AddOnInfo.get('Dosage')?.setValue(drug.schedule ?? '');
    this.selectedDrugId = drug.id;

    this.initializeDrugCtrlSubscription();
    this.initializeDINCtrlSubscription();
    this.isDrugvalid = true;
  }

  onDrugblur(){
    if(this.selectedDrugId == 0){
      this.isDrugvalid = false;
    }
    else{
      this.isDrugvalid = true;
    }
  }

  // Set default address from the address list
  setDefaultValueForAddress() {
    const defaultAddress = this.addressList.find(
      (address) => address.is_default === '1'
    );
    if (defaultAddress) {
      this.manualForm.get('address').setValue(defaultAddress.shipping_address);
      this.addressId = defaultAddress.id;
    }
  }

  // Handle address selection
  onSelectAddress(address: Address) {
    this.addressId = address.id;
    //console.log(address);
  }

  // Fetch address list
  getlist(user_id: string) {
    this.progress_spinner = true;
    this.manualService.getAddresses({ user_id }).subscribe((res) => {
      if (res?.body?.success) {
        this.addressList = res?.body?.data;
        this.setDefaultValueForAddress();
        this.getInsuranceList(user_id);
        this.progress_spinner = false;
      } else {
        console.error('error::');
      }
    });
  }

  // Unsubscribe from subscriptions to prevent memory leaks
  // ngOnDestroy() {
  //   this.patientCtrlSubscription.unsubscribe();
  // }

  // Open modal for adding orders
  openAddModal(selectedUserId: string) {
    const dialogRef = this.dialog.open(AddOrderModalComponent, {
      width: '1080px',
      data: { userId: selectedUserId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getlist(selectedUserId);
    });
  }

  onSelectionChange(event: MatSelectChange) {
    const selectedIds = event.value;
    this.selectedInsurance = event.value;
    this.SelectedInsuranceName = this.insuranceList.find(
      (insurance) => insurance.id === this.selectedInsurance
    );
    //console.log(this.insuranceList);
  }

  // Open modal for adding Insurance
  openAddInsuranceModal(selectedUserId: string) {
    const dialogRef = this.dialog.open(AddInsuranceModalComponent, {
      width: '1080px',
      data: { userId: selectedUserId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // this.getlist(selectedUserId);
      this.getInsuranceList(selectedUserId);
    });
  }

  // Fetch insurance list for a user
  getInsuranceList(user_id: string) {
    this.manualService.getInsuranceList({ user_id }).subscribe((res) => {
      if (res?.body.success) {
        this.insuranceList = res?.body?.data?.user_benefits;
        this.DefaultInsuranceArray = this.insuranceList;
        //console.log('ress of insurance::', this.insuranceList);
      } else {
        console.error('error::');
      }
    });
  }

  // Add Rx details in Array
  AddRxDetailItem() {  
    if (this.AddOnInfo.valid) {
      const rxIdValue = this.AddOnInfo.get('RxId').value.toString();
      const OrxIdValue = this.AddOnInfo.get('OrignalRxId').value.toString();
      let isIdExists = this.AddOnInfoData.find((item) => item.ID === rxIdValue);
      let isIdExists1 = this.AddOnInfoData.find((item) => item.OrigRxNum === OrxIdValue);

      //console.log("IsRxEditMode",this.IsRxEditMode);
      
      if(this.IsRxEditMode){
        isIdExists = false;
        isIdExists1 = false;
      }


      if (isIdExists && isIdExists1) {
        //console.log("If",isIdExists,' ',isIdExists1);
        this.toastr.error(`Orignal Rx/Rx Number already exists`);
        return;
      } 
      else 
      {
        if (this.IfRxIdValid && this.IfORxIdValid) {
          //console.log("else if",isIdExists,' ',isIdExists1);
          this.toastr.error(`Orignal Rx/Rx Number already exists`);
        } 
        else 
        {
            if(this.AddOnInfo.get('DrugID').value == null || this.AddOnInfo.get('DrugID').value == ''){
              this.toastr.error('Please select Drug in drug list.');
              return;
            }

            if (this.AddOnInfo.get('AvailableQty').value <= 0){
              this.toastr.error("There's no remaining quantity left on this Rx, order cannot be created.");
              this.isQtyvalid = false;
              return;
            }

            
            if (parseFloat(this.AddOnInfo.get('Cash').value) != 0) {
              this.InsuranceArray.push({
                pays: this.AddOnInfo.get('Cash').value,
                subplan: 0,
                CareerNumber: 0,
                subplanname: 'Cash',
              });
            } 
            
            if(this.IsRxEditMode){
              let updatedElement = {
                ID: this.AddOnInfo.get('RxId').value,
                OrigRxNum: this.AddOnInfo.get('OrignalRxId').value,
                PatID: null,
                address_id: null,
                DrugName: this.AddOnInfo.get('DrugName').value,
                DrgID: this.AddOnInfo.get('DrugID').value,
                RxNum: this.AddOnInfo.get('RxId').value,
                AAC: (this.AddOnInfo.get('Cost').value == ''? 0: this.AddOnInfo.get('Cost').value).toString(),
                Cost: (this.AddOnInfo.get('Cost').value == ''? 0: this.AddOnInfo.get('Cost').value).toString(),
                Markup: (this.AddOnInfo.get('Markup').value == ''? 0: this.AddOnInfo.get('Markup').value).toString(),
                Fee: (this.AddOnInfo.get('Fee').value == ''? 0: this.AddOnInfo.get('Fee').value).toString(),
                BaseCost: (this.AddOnInfo.get('Cost').value == ''? 0: this.AddOnInfo.get('Cost').value).toString(),
                DiscountCost: (this.AddOnInfo.get('DiscountCost').value == ''? 0: this.AddOnInfo.get('DiscountCost').value).toString(),
                DiscountMarkup: (this.AddOnInfo.get('DiscountMarkup').value == ''? 0: this.AddOnInfo.get('DiscountMarkup').value).toString(),
                DiscountFee: (this.AddOnInfo.get('DiscountFee').value == ''? 0: this.AddOnInfo.get('DiscountFee').value).toString(),
                DispQty: this.AddOnInfo.get('DispQty').value == ''? 0: this.AddOnInfo.get('DispQty').value,
                NextFillQty: this.AddOnInfo.get('NextFillQty').value == ''? 0: this.AddOnInfo.get('NextFillQty').value,
                Lastfilledqty: this.AddOnInfo.get('Lastfilledqty').value == ''? 0: this.AddOnInfo.get('Lastfilledqty').value,
                AuthQty: this.AddOnInfo.get('Authqty').value == ''? 0: this.AddOnInfo.get('Authqty').value,
                RemQty: this.AddOnInfo.get('Remainingqty').value == ''? 0: this.AddOnInfo.get('Remainingqty').value,
                AvailableQty: this.AddOnInfo.get('AvailableQty').value == ''? 0: this.AddOnInfo.get('AvailableQty').value,
                AutoRefill: this.AddOnInfo.get('AutoRefill').value ? 1 : 0,
                DaysSupply: this.AddOnInfo.get('DaysSupply').value == ''? 0: this.AddOnInfo.get('DaysSupply').value,
                FillDate: this.AddOnInfo.get('Filldate').value,
                FirstFillDate: this.AddOnInfo.get('FirstFilleddate').value,
                LastFillDate:  this.AddOnInfo.get('LastFilleddate').value,
                FillExpiryDate: this.AddOnInfo.get('FillExpiryDate').value,
                RxID: this.AddOnInfo.get('RxId').value,
                kroll_drg: {
                  ID: this.AddOnInfo.get('DrugID').value,
                  BrandName: this.AddOnInfo.get('DrugName').value,
                  GenericName: this.AddOnInfo.get('DrugName').value,
                  Strength: this.AddOnInfo.get('Strength').value,
                  DIN: this.AddOnInfo.get('DIN').value,
                  Form: this.AddOnInfo.get('Form').value,
                  Schedule: this.AddOnInfo.get('Dosage').value,
                  Instructions: this.AddOnInfo.get('Instructions').value,
                },
                Insurancedata: this.InsuranceArray,
              };
              this.AddOnInfoData[this.EditIndex] = updatedElement;
              this.EditIndex = 0;
              this.IsRxEditMode = false;
              this.Is2nd = false;
              this.toastr.success('Item update successfully..');
              this.RxButton = 'Add More';
              //this.AddOnInfoReset();
              this.initializeAddonInfo();
            }
            else
            {
              this.AddOnInfoData.push({
                ID: this.AddOnInfo.get('RxId').value,
                OrigRxNum: this.AddOnInfo.get('OrignalRxId').value,
                PatID: null,
                address_id: null,
                DrugName: this.AddOnInfo.get('DrugName').value,
                DrgID: this.AddOnInfo.get('DrugID').value,
                RxNum: this.AddOnInfo.get('RxId').value,
                AAC: (this.AddOnInfo.get('Cost').value == ''? 0: this.AddOnInfo.get('Cost').value).toString(),
                Cost: (this.AddOnInfo.get('Cost').value == ''? 0: this.AddOnInfo.get('Cost').value).toString(),
                Markup: (this.AddOnInfo.get('Markup').value == ''? 0: this.AddOnInfo.get('Markup').value).toString(),
                Fee: (this.AddOnInfo.get('Fee').value == ''? 0: this.AddOnInfo.get('Fee').value).toString(),
                BaseCost: (this.AddOnInfo.get('Cost').value == ''? 0: this.AddOnInfo.get('Cost').value).toString(),
                DiscountCost: (this.AddOnInfo.get('DiscountCost').value == ''? 0: this.AddOnInfo.get('DiscountCost').value).toString(),
                DiscountMarkup: (this.AddOnInfo.get('DiscountMarkup').value == ''? 0: this.AddOnInfo.get('DiscountMarkup').value).toString(),
                DiscountFee: (this.AddOnInfo.get('DiscountFee').value == ''? 0: this.AddOnInfo.get('DiscountFee').value).toString(),
                DispQty: this.AddOnInfo.get('DispQty').value == ''? 0: this.AddOnInfo.get('DispQty').value,
                NextFillQty: this.AddOnInfo.get('NextFillQty').value == ''? 0: this.AddOnInfo.get('NextFillQty').value,
                Lastfilledqty: this.AddOnInfo.get('Lastfilledqty').value == ''? 0: this.AddOnInfo.get('Lastfilledqty').value,
                AuthQty: this.AddOnInfo.get('Authqty').value == ''? 0: this.AddOnInfo.get('Authqty').value,
                RemQty: this.AddOnInfo.get('Remainingqty').value == ''? 0: this.AddOnInfo.get('Remainingqty').value,
                AvailableQty: this.AddOnInfo.get('AvailableQty').value == ''? 0: this.AddOnInfo.get('AvailableQty').value,
                AutoRefill: this.AddOnInfo.get('AutoRefill').value ? 1 : 0,
                DaysSupply: this.AddOnInfo.get('DaysSupply').value == ''? 0: this.AddOnInfo.get('DaysSupply').value,
                FillDate: this.AddOnInfo.get('Filldate').value,
                FirstFillDate: this.AddOnInfo.get('FirstFilleddate').value,
                LastFillDate: this.AddOnInfo.get('LastFilleddate').value,
                FillExpiryDate: this.AddOnInfo.get('FillExpiryDate').value,
                RxID: this.AddOnInfo.get('RxId').value,
                kroll_drg: {
                  ID: this.AddOnInfo.get('DrugID').value,
                  BrandName: this.AddOnInfo.get('DrugName').value,
                  GenericName: this.AddOnInfo.get('DrugName').value,
                  Strength: this.AddOnInfo.get('Strength').value,
                  DIN: this.AddOnInfo.get('DIN').value,
                  Form: this.AddOnInfo.get('Form').value,
                  Schedule: this.AddOnInfo.get('Dosage').value,
                  Instructions: this.AddOnInfo.get('Instructions').value,
                },
                Insurancedata: this.InsuranceArray,
              });
              this.toastr.success('Item added successfully.');
            }
            this.IsRxsValid = false;
            this.IfORxIdValid = false;
            this.AddOnInfo.reset();
            this.Is2nd = false;
            //console.log('AddOnInfoData', this.AddOnInfoData);
            this.drugList = [];
            this.InsuranceArray = [];
            this.Copay = 0;
            this.AddOnInfo.get('RxId').enable();
            this.AddOnInfo.get('OrignalRxId').enable();
            this.initializeAddonInfo();
            this.initializeDrugCtrlSubscription();
            this.initializeDINCtrlSubscription();
            this.insuranceList = this.DefaultInsuranceArray;
            this.isQtyvalid = true;

            //this.AddOnInfoReset();
            this.CalculateRemaningDate();
        }
      }
    }
  }

  // Remove Rx Detail from array
  RemoveRxDetail(index: any) {
    this.AddOnInfoData.splice(index, 1);
  }

  onSelectDIN(din: any) {
    this.AddOnInfo.get('DrugName')?.setValue(din.name);
    this.AddOnInfo.get('DrugID')?.setValue(din.id);
    this.AddOnInfo.get('Strength')?.setValue(din.strength ?? '');
    this.AddOnInfo.get('DIN')?.setValue(din.din ?? '');
    this.AddOnInfo.get('Form')?.setValue(din.durg_from ?? '');
    this.AddOnInfo.get('Dosage')?.setValue(din.schedule ?? '');
    this.selectedDrugId = din.id;
    this.drugCtrlSubscription.unsubscribe();
    this.initializeDrugCtrlSubscription();
    this.initializeDINCtrlSubscription();
    this.isDrugvalid = true;
  }

  initializeDINCtrlSubscription() {
    this.drugCtrlSubscription = this.AddOnInfo.get('DIN')
      .valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => (this.progress_spinner = true)),
        switchMap((searchTerm: any) => {
          if (searchTerm.length >= 1) {
            return this.manualService.getDrugList({ search: searchTerm }).pipe(
              map(
                (response) => {
                  if (response?.body?.success) {
                    this.DINList = response?.body?.data;
                    //console.log(this.DINList);
                    this.progress_spinner = false;
                    return response?.body?.data;
                  } else {
                    this.progress_spinner = false;
                    return [];
                  }
                },
                (err: any) => {
                  console.error('API FAILED', err);
                }
              )
            );
          } else {
            this.progress_spinner = false;
            this.DINList = [];
            return [];
          }
        }),
        tap(() => (this.progress_spinner = false))
      )
      .subscribe((drugs: any[]) => {
        this.DINList = drugs;
      });
  }

  // Rx Detail Collaps
  toggleCollapse(rxId: string) {
    this.isCollapsed[rxId] = !this.isCollapsed[rxId];
  }

  checkrxid(Rxnum: number) {
    if(this.IsRxEditMode){
      this.IfRxIdValid = false;
      return;
    }
    if (Rxnum == 1) {
      const rxIdValue = this.AddOnInfo.get('RxId').value.toString();
      const isIdExists = this.AddOnInfoData.find(
        (item) => item.ID === rxIdValue
      );
      if (isIdExists) {
        this.IfRxIdValid = true;
        this.toastr.error(`Rx Number ${this.AddOnInfo.get('RxId').value} already exists`);
        return;
      } else {
        this.IfRxIdValid = false;
      }
    } else if (Rxnum == 2) {
      const rxIdValue = this.AddOnInfo.get('OrignalRxId').value.toString();
      const isIdExists = this.AddOnInfoData.find((item) => item.OrigRxNum === rxIdValue);
      if (isIdExists) {
        this.IfORxIdValid = true;
        this.toastr.error(`Orignal Rx Number ${this.AddOnInfo.get('OrignalRxId').value} already exists`);
        return;
      } else {
        this.IfORxIdValid = false;
      }
    }
  }

  CalculateRemaningQty() {
    const _Authqty = this.AddOnInfo.get('AvailableQty').value;
    const _DispQty = this.AddOnInfo.get('DispQty').value;
    const Rqty = _Authqty - _DispQty;
    if (Rqty < 0) {
      this.AddOnInfo.get('DispQty').setValue(
        this.AddOnInfo.get('AvailableQty').value
      );
      this.AddOnInfo.get('Remainingqty').setValue(0);
    } else {
      this.AddOnInfo.get('Remainingqty').setValue(Rqty);
    }
    // this.AddOnInfo.get('Remainingqty').disable();
  }

  AddManualData() {
    //alert(this.manualForm.get('shippingType').value);
    if (this.manualForm.get('patient').value == '') {
      this.toastr.error('Please select patient.');
      return;
    }
    if (this.manualForm.get('address').value == '') {
      this.toastr.error('Please select address.');
      return;
    }
    if (this.manualForm.get('shippingType').value == '') {
      this.toastr.error('Please select shipping type.');
      return;
    }

    if(this.patientId == 0 || this.patientId == null){
      this.toastr.error('Please select Patient from patient list.');
      return;
    }

    this.AddRxDetailItem();
    if(!this.isQtyvalid){
      return;
    }
    
    if (this.AddOnInfoData.length == 0) {
      this.toastr.error('Please enter required details.');
      return;
    } else {
      const Data = {
        user_id: this.patientId,
        user_visit_id: this.vid,
        address_id: this.addressId,
        shipping_type: this.manualForm.get('shippingType').value,
        server_location: this.formService.selectedLocation.value,
        IsManual: true,
        NH_Detail: this.NursingData,
        rxDetails: this.AddOnInfoData,
      };
      this.manualService.saveManualOrder(Data).subscribe(
        (res: any) => {
          //console.log(res);
          if (res.body.success) {
            this.toastr.success(res.body.message);
            this.router.navigate(
              [this.RouteConstants.SalesOrder.SalesOrder.Route],
              {
                queryParams: {
                  page: 1,
                  per_page: 10,
                  type: this.manualForm.get('shippingType').value,
                  server_location: this.helperService.getLocalStorage('serverLocation'),
                  order_status: '1,2,3,11,13,14',
                },
              }
            );
          } else {
            this.toastr.error(res.message);
          }
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    }
  }

  AddInsurance() {
    this.AddInsuranceform.get('subplan').setValue(this.selectedInsurance);    

    const _cost = this.AddOnInfo.get('Cost').value === '' ? 0 : parseFloat(this.AddOnInfo.get('Cost').value);
    const _Markup = this.AddOnInfo.get('Markup').value === '' ? 0 : parseFloat(this.AddOnInfo.get('Markup').value);
    const _Fee = this.AddOnInfo.get('Fee').value === '' ? 0 : parseFloat(this.AddOnInfo.get('Fee').value);
    const _DiscountCost = this.AddOnInfo.get('DiscountCost').value === '' ? 0 : parseFloat(this.AddOnInfo.get('DiscountCost').value);
    const _DiscountMarkup = this.AddOnInfo.get('DiscountMarkup').value === '' ? 0 : parseFloat(this.AddOnInfo.get('DiscountMarkup').value);
    const _DiscountFee = this.AddOnInfo.get('DiscountFee').value === '' ? 0 : parseFloat(this.AddOnInfo.get('DiscountFee').value);

    const Total = ((_cost + _Markup + _Fee) - (_DiscountCost + _DiscountMarkup + _DiscountFee));
    var sum = this.InsuranceArray.reduce((acc, obj) => acc + obj.pays, 0);

    if((parseFloat(sum == undefined ? 0 : sum) + parseFloat(this.AddInsuranceform.get('pays').value)) > Total){
      this.toastr.error('Copay Amount not be negative.');
      return;
    }

    if (this.AddInsuranceform.valid) {
      this.InsuranceArray.push({
        pays: this.AddInsuranceform.get('pays').value,
        subplan: this.selectedInsurance,
        CareerNumber: this.SelectedInsuranceName.career_number,
        subplanname: this.SelectedInsuranceName.insurance_provider,
      });

      this.setCash();
      this.insuranceList = this.insuranceList.filter((item) => item.id !== this.selectedInsurance);

      this.AddInsuranceform.reset();
      this.SelectedInsuranceName = '';
      this.selectedInsurance = '';
      this.toastr.success('Insurance add successfully.');
    } else {
      this.toastr.error('Please fill insurance details.');
    }
  }

  RemoveInsurance(index: any) {
    const rdata = this.InsuranceArray[index];
    
    if(rdata.subplanname == 'Cash'){
      this.InsuranceArray = this.InsuranceArray.filter(item => item.subplanname !== "Cash");
      this.setCash();
    }else{
      this.insuranceList.push(
        this.DefaultInsuranceArray.find((x) => x.id == rdata.subplan)
      );
      this.InsuranceArray.splice(index, 1);
      this.AddOnInfo.Insurancedata = this.InsuranceArray;

      // console.log("array",this.InsuranceArray);
      
      // console.log("fdata", this.AddOnInfo.Insurancedata);
      
      // var sum = this.InsuranceArray.reduce((acc, obj) => acc + obj.pays, 0);
      // this.Copay = (parseFloat(this.AddOnInfo.get('Cost').value) - parseFloat(sum));
      // this.AddOnInfo.get('Cash').setValue(this.Copay);
      this.setCash();
    }
  }

  CalculateRemaningDate() {
    let date = new Date(this.AddOnInfo.get('Filldate').value);
    if(parseInt(this.AddOnInfo.get('DaysSupply').value) > 0){
      date.setDate(
        date.getDate() + (parseInt(this.AddOnInfo.get('DaysSupply').value) - 1)
      );
      this.AddOnInfo.get('FillExpiryDate').setValue(
        date.toISOString().split('T')[0]
      );
    }else{
      date.setDate(date.getDate());
      this.AddOnInfo.get('FillExpiryDate').setValue(
        date.toISOString().split('T')[0]
      );
    }
  }

  setAvailableQty() {
    this.AddOnInfo.get('AvailableQty').setValue(
      this.AddOnInfo.get('Authqty').value
    );
    // this.AddOnInfo.get('AvailableQty').disable();
  }

  setCash() {
    let _cost = this.AddOnInfo.get('Cost').value;
    let _Markup = this.AddOnInfo.get('Markup').value;
    let _Fee = this.AddOnInfo.get('Fee').value;
    let _DiscountCost = this.AddOnInfo.get('DiscountCost').value;
    let _DiscountMarkup = this.AddOnInfo.get('DiscountMarkup').value;
    let _DiscountFee = this.AddOnInfo.get('DiscountFee').value;

    let Total = (((isNaN(parseFloat(_cost)) ? 0 : parseFloat(_cost)) + (isNaN(parseFloat(_Markup)) ? 0 : parseFloat(_Markup)) + (isNaN(parseFloat(_Fee)) ? 0 : parseFloat(_Fee))) -( (isNaN(parseFloat(_DiscountCost)) ? 0 : parseFloat(_DiscountCost)) + (isNaN(parseFloat(_DiscountMarkup)) ? 0 : parseFloat(_DiscountMarkup)) + (isNaN(parseFloat(_DiscountFee)) ? 0 : parseFloat(_DiscountFee))));

    
    let sum =  parseFloat(this.InsuranceArray.reduce((acc, obj) => acc + obj.pays, 0));
    if(this.InsuranceArray.length > 0){
      //this.Copay =  (Total - parseFloat(sum == undefined ? 0 : sum));
      this.Copay =  parseFloat((Total - sum).toFixed(2));
      this.AddOnInfo.get('Cash').setValue(Number.isNaN(this.Copay) ? 0 :this.Copay);
    }else{
      this.Copay = parseFloat((Total - sum).toFixed(2));
      this.AddOnInfo.get('Cash').setValue(Number.isNaN(this.Copay) ? 0 :this.Copay);
    }
  }

  ValidateRx() {
    if (this.manualForm.get('patient').value == '') {
      this.toastr.error('Please select patient.');
      return;
    }

    if (this.AddOnInfo.get('OrignalRxId').value == '') {
      this.toastr.error('Please enter Orignal Rx Number.');
      return;
    }
    if (this.AddOnInfo.get('RxId').value == '') {
      this.toastr.error('Please enter Rx Number.');
      return;
    }

    const payloadData = {
      user_id: this.patientId,
      RxNum: this.AddOnInfo.get('RxId').value,
      OrigRxNum: this.AddOnInfo.get('OrignalRxId').value,
    };

    this.manualService.ValidateRxDetail(payloadData).subscribe(
      (res: any) => {
        //console.log("res",res);
        if (res.body.success) {
          if(res.body.data.length > 0){
            this.Is2nd = true;
            var existingData = res.body.data[0];
            //console.log(existingData);
            
            this.initializeAddonInfo();

            this.setRxFormData(existingData);
            if (existingData.RemQty <= 0){
              this.toastr.error("There's no remaining quantity left on this Rx, order cannot be created.");
            }
            setTimeout(() => {
              this.AddOnInfo.get('RxId').disable();
              this.AddOnInfo.get('OrignalRxId').disable();
            }, 1000);
          }
          this.toastr.success(res.body.message);
          this.IsRxsValid = true;
          this.AddOnInfo.get('RxId').setValue(payloadData.RxNum);
          this.AddOnInfo.get('OrignalRxId').setValue(payloadData.OrigRxNum);
        } else {
          this.IsRxsValid = false;
          this.toastr.error(res.body.message);
        }
      },
      (err) => {
        this.toastr.error(err.message);
      }
    );
  }

  setRxFormData(data: any){
    //console.log(data);
    //alert(data.FillDate);
    
    this.AddOnInfo.get('DrugID').setValue(data.DrgID);
    this.AddOnInfo.get('DrugName').setValue(data.DrugGenericName);
    this.AddOnInfo.get('DIN').setValue(data.kroll_drg.DIN);
    this.AddOnInfo.get('Strength')?.setValue(data.kroll_drg.Strength);
    this.AddOnInfo.get('Form').setValue(data.kroll_drg.Form);
    this.AddOnInfo.get('Dosage').setValue(data.kroll_drg.Schedule);
    this.AddOnInfo.get('Instructions').setValue(data.SIG);
    this.AddOnInfo.get('Authqty').setValue(data.AuthQty);
    this.AddOnInfo.get('AvailableQty').setValue(data.RemQty);
    this.AddOnInfo.get('DispQty').setValue(data.DispQty);
    this.CalculateRemaningQty();
    this.AddOnInfo.get('Lastfilledqty').setValue(data.DispQty);
    //this.AddOnInfo.get('Remainingqty').setValue(data.RemQty);
    this.AddOnInfo.get('NextFillQty').setValue(data.NextFillDate);
    this.AddOnInfo.get('DaysSupply').setValue(data.DaysSupply);
    this.AddOnInfo.get('FirstFilleddate').setValue(data.FirstFillDate);
    this.AddOnInfo.get('FirstFilleddate').disable();
    this.AddOnInfo.get('LastFilleddate').setValue(data.FillDate.substring(0, 10));
    //this.AddOnInfo.get('Filldate').setValue(data.FillDate.substring(0, 10));
    this.CalculateRemaningDate();
    this.AddOnInfo.get('AutoRefill').setValue(data.AutoRefill === 1);
    // this.AddOnInfo.get('AAC').setValue();
    // this.AddOnInfo.get('Cost').setValue();
    // this.AddOnInfo.get('Markup').setValue();
    // this.AddOnInfo.get('Fee').setValue();
    // this.AddOnInfo.get('BaseCost').setValue();
    // this.AddOnInfo.get('DiscountCost').setValue();
    // this.AddOnInfo.get('DiscountMarkup').setValue();
    // this.AddOnInfo.get('DiscountFee').setValue();
    // this.AddOnInfo.get('Cash').setValue();
  }

  openAddModalDrug() {
    const dialogRef = this.dialog.open(AddDrugModalComponent, {
      width: '1080px',
      //data: { userId: selectedUserId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      //console.log(result);
      this.selectedDrugId = result.id;
      this.AddOnInfo.get('DrugID')?.setValue(result.id);
      this.AddOnInfo.get('DrugName')?.setValue(result.name);
      this.AddOnInfo.get('Strength')?.setValue(result.strength ?? '');
      this.AddOnInfo.get('DIN')?.setValue(result.din ?? '');
      this.AddOnInfo.get('Form')?.setValue(result.durg_from ?? '');
      this.AddOnInfo.get('Dosage')?.setValue(result.schedule ?? '');
      this.initializeDrugCtrlSubscription();
      this.initializeDINCtrlSubscription();
      this.isDrugvalid = true;
    });
  }

  dateValidator(group: FormGroup): any {
    const firstDate = group.controls.FirstFilleddate.value;
    const secondDate = group.controls.LastFilleddate.value;
    const thirdDate = group.controls.Filldate.value;
    
    if ((secondDate && firstDate) && secondDate < firstDate) {
      return { dateError: true };
    }
    if ((thirdDate && firstDate) && thirdDate < firstDate) {
      return { dateError: true };
    }
    return false;
  }

  clearRx(){
    this.AddOnInfo.reset();
    this.AddInsuranceform.reset();
    this.AddOnInfo.get('RxId').enable();
    this.AddOnInfo.get('OrignalRxId').enable();
    //this.AddOnInfoData = [];
    this.selectedInsurance ='';
    this.InsuranceArray = [];
    this.SelectedInsuranceName = '';
    this.DefaultInsuranceArray = []; 
    this.selectedDrugId = 0;
    this.drugList = [];
    this.IfRxIdValid = false;
    this.IfORxIdValid = false;
    this.IsRxsValid = false;
    this.Copay = 0;
    // Check the current value of shippingType to set IsNursingDDActive
    const shippingType = this.manualForm.get('shippingType')?.value;
    this.IsNursingDDActive = shippingType.toLowerCase() == 'chronic';
    this.Is2nd = false;
    this.isDrugvalid = true;

    //this.initializeForm();

    
    //this.AddOnInfoReset();
    this.initializeAddonInfo();

    this.initializeDrugCtrlSubscription();
    this.initializeDINCtrlSubscription();
  }

  EditRx(rowIndex: any){
    this.EditIndex = rowIndex;
    this.IsRxsValid = true; 
    this.IfRxIdValid = false;
    this.IfORxIdValid = false;
    const editReqfor = this.AddOnInfoData[rowIndex];

    var CashData = editReqfor.Insurancedata.filter((item:any) => item.subplanname == "Cash");
    this.AddOnInfo.get('Cash').setValue(parseFloat(CashData.pays));
    this.Copay = parseFloat(CashData.pays);


    this.InsuranceArray = editReqfor.Insurancedata.filter((item:any) => item.subplanname != "Cash");

    //console.log(this.InsuranceArray);
    
    
    this.AddOnInfo.get('RxId').setValue(editReqfor.RxID);
    this.AddOnInfo.get('OrignalRxId').setValue(editReqfor.OrigRxNum);
    this.AddOnInfo.get('DrugID').setValue(editReqfor.DrgID);
    this.AddOnInfo.get('DrugName').setValue(editReqfor.kroll_drg.BrandName);
    this.AddOnInfo.get('Strength').setValue(editReqfor.kroll_drg.Strength);
    this.AddOnInfo.get('DIN').setValue(editReqfor.kroll_drg.DIN);
    this.AddOnInfo.get('Form').setValue(editReqfor.kroll_drg.Form);
    this.AddOnInfo.get('Dosage').setValue(editReqfor.kroll_drg.Schedule);
    this.AddOnInfo.get('Instructions').setValue(editReqfor.kroll_drg.Instructions);
    this.AddOnInfo.get('Authqty').setValue(editReqfor.AuthQty);
    this.AddOnInfo.get('AvailableQty').setValue(editReqfor.AvailableQty);
    this.AddOnInfo.get('Lastfilledqty').setValue(editReqfor.Lastfilledqty);
    this.AddOnInfo.get('Remainingqty').setValue(editReqfor.RemQty);
    this.AddOnInfo.get('DispQty').setValue(editReqfor.DispQty);
    this.AddOnInfo.get('NextFillQty').setValue(editReqfor.NextFillQty);
    this.AddOnInfo.get('DaysSupply').setValue(editReqfor.DaysSupply);
    this.AddOnInfo.get('FirstFilleddate').setValue(editReqfor.FirstFillDate);
    this.AddOnInfo.get('LastFilleddate').setValue(editReqfor.LastFillDate)
    this.AddOnInfo.get('Filldate').setValue(editReqfor.FillDate);
    this.AddOnInfo.get('FillExpiryDate').setValue(editReqfor.FillExpiryDate);
    this.AddOnInfo.get('AutoRefill').setValue(editReqfor.AutoRefill);
    this.AddOnInfo.get('AAC').setValue(editReqfor.AAC);
    this.AddOnInfo.get('Cost').setValue(editReqfor.Cost);
    this.AddOnInfo.get('Markup').setValue(editReqfor.Markup);
    this.AddOnInfo.get('Fee').setValue(editReqfor.Fee);
    this.AddOnInfo.get('BaseCost').setValue(editReqfor.BaseCost);
    this.AddOnInfo.get('DiscountCost').setValue(editReqfor.DiscountCost);
    this.AddOnInfo.get('DiscountMarkup').setValue(editReqfor.DiscountMarkup);
    this.AddOnInfo.get('DiscountFee').setValue(editReqfor.DiscountFee);
    this.AddOnInfo.Insurancedata = this.InsuranceArray;
    //console.log(this.AddOnInfo.Insurancedata); 
    //this.getInsuranceList(this.patientId);
    this.setCash();
    this.IsRxEditMode = true;

    this.insuranceList = this.insuranceList.filter(insurance => 
      !this.InsuranceArray.some(insuranceArrayItem => insuranceArrayItem.subplan === insurance.id)
    );

    this.isCollapsed[editReqfor.RxID] = false;
    this.RxButton = 'Update';
    //console.log("l",this.insuranceList);
    
    
  }


  openAddNursingHomeModal() {
    const dialogRef = this.dialog.open(AddNursingHomeModalComponent, {
      width: '650px',
      data: { location: this.formService.selectedLocation.value },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getNursingHome();
    });
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${month}/${day}/${year}`;
  }
}
